<div
    class="tw-toast group relative flex w-[360px] items-start gap-3 overflow-hidden rounded-2xl bg-white p-4 ring-1 ring-inset ring-zinc-200/70 shadow-popMenu"
    role="status">
    <!-- Status accent stripe -->
    <span
        aria-hidden="true"
        class="absolute inset-y-0 left-0 w-[3px]"
        [class.bg-emerald-500]="toastPackage.toastType === 'toast-success'"
        [class.bg-primary-500]="toastPackage.toastType === 'toast-info'"
        [class.bg-amber-500]="toastPackage.toastType === 'toast-warning'"
        [class.bg-red-500]="toastPackage.toastType === 'toast-error'"></span>

    <!-- Icon tile -->
    <span
        class="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-xl ring-1 ring-inset"
        [class.bg-emerald-50]="toastPackage.toastType === 'toast-success'"
        [class.text-emerald-600]="toastPackage.toastType === 'toast-success'"
        [class.ring-emerald-100]="toastPackage.toastType === 'toast-success'"
        [class.bg-primary-50]="toastPackage.toastType === 'toast-info'"
        [class.text-primary-700]="toastPackage.toastType === 'toast-info'"
        [class.ring-primary-100]="toastPackage.toastType === 'toast-info'"
        [class.bg-amber-50]="toastPackage.toastType === 'toast-warning'"
        [class.text-amber-600]="toastPackage.toastType === 'toast-warning'"
        [class.ring-amber-100]="toastPackage.toastType === 'toast-warning'"
        [class.bg-red-50]="toastPackage.toastType === 'toast-error'"
        [class.text-red-600]="toastPackage.toastType === 'toast-error'"
        [class.ring-red-100]="toastPackage.toastType === 'toast-error'">
        @switch (toastPackage.toastType) {
            @case ('toast-success') {
                <lucide-icon [img]="CheckIcon" [size]="16" [strokeWidth]="2" />
            }
            @case ('toast-info') {
                <lucide-icon [img]="InfoIcon" [size]="16" [strokeWidth]="2" />
            }
            @case ('toast-warning') {
                <lucide-icon [img]="AlertIcon" [size]="16" [strokeWidth]="2" />
            }
            @case ('toast-error') {
                <lucide-icon [img]="XCircleIcon" [size]="16" [strokeWidth]="2" />
            }
        }
    </span>

    <!-- Content -->
    <div class="flex min-w-0 flex-1 flex-col gap-0.5 pt-px">
        @if (getTitle()) {
            <h3
                class="text-[13px] font-semibold leading-tight tracking-[-0.005em] text-twTextPrimary"
                [attr.aria-label]="title">
                {{ getTitle() | translate }}
            </h3>
        }

        @if (message && options.enableHtml) {
            <div
                class="text-[12.5px] leading-snug text-zinc-600 [&_a]:text-primary-700 [&_a]:underline [&_a]:underline-offset-2"
                role="alert"
                [innerHTML]="message"></div>
        }
        @if (message && !options.enableHtml) {
            <div
                class="text-[12.5px] leading-snug text-zinc-600"
                role="alert"
                [attr.aria-label]="message">
                {{ message }}
            </div>
        }
    </div>

    <!-- Close button -->
    <button
        type="button"
        class="-mr-1 -mt-1 flex size-7 shrink-0 items-center justify-center rounded-lg text-zinc-400 opacity-0 transition-all hover:bg-zinc-100 hover:text-twTextPrimary group-hover:opacity-100 focus:opacity-100"
        aria-label="Close"
        (click)="closeToast($event)">
        <lucide-icon [img]="XIcon" [size]="14" [strokeWidth]="1.75" />
    </button>

    @if (options.progressBar) {
        <div
            class="absolute bottom-0 left-0 right-0 h-[2px] overflow-hidden bg-zinc-100/70">
            <div
                class="h-full transition-[width] duration-200 ease-linear"
                [class.bg-emerald-500]="toastPackage.toastType === 'toast-success'"
                [class.bg-primary-500]="toastPackage.toastType === 'toast-info'"
                [class.bg-amber-500]="toastPackage.toastType === 'toast-warning'"
                [class.bg-red-500]="toastPackage.toastType === 'toast-error'"
                [style.width.%]="width()"></div>
        </div>
    }
</div>
